import { useState, type FormEvent } from 'react';
import { api } from '../api';
import { Modal } from '../components/Modal';
import { useToast } from '../components/Toast';
import { Button, ErrorAlert, Field, Input } from '../components/ui';

export function ChangePasswordForm({ onDone, onCancel, cancelLabel = 'Cancel' }: { onDone: () => void; onCancel?: () => void; cancelLabel?: string }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  const mismatch = confirm.length > 0 && next !== confirm;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) return;
    setBusy(true);
    setError(null);
    try {
      await api.changePassword(current, next);
      onDone();
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="stack" onSubmit={submit}>
      <ErrorAlert error={error} />
      <Field label="Current password">
        <Input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoFocus />
      </Field>
      <Field label="New password" hint="At least 12 characters. A phrase of several words works well.">
        <Input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required />
      </Field>
      <Field label="Confirm new password" error={mismatch ? 'The passwords do not match' : null}>
        <Input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
      </Field>
      <div className="row end">
        {onCancel && <Button onClick={onCancel}>{cancelLabel}</Button>}
        <Button type="submit" variant="primary" loading={busy} disabled={!current || !next || next !== confirm}>
          Change password
        </Button>
      </div>
    </form>
  );
}

export function ChangePasswordDialog({ onClose }: { onClose: () => void }) {
  const toast = useToast();
  return (
    <Modal title="Change password" onClose={onClose}>
      <p className="muted">Changing your password signs out your other sessions.</p>
      <ChangePasswordForm
        onCancel={onClose}
        onDone={() => {
          toast.success('Password changed');
          onClose();
        }}
      />
    </Modal>
  );
}
